<template>
    <div class="ur-data-grid__content__group-summary__cell" :style="tdStyle" :class="tdClass">
        <div class="ur-data-grid__content__group-summary__value ur-data-grid__content__cell__value" :style="valueStyle"
                v-ur-tooltip.overflow.empty="$_text" v-if="$_text">{{$_text}}</div>
    </div>
</template>

<script>
import {dateToText} from '../../util'
export default {
    name : 'urDataGridGroupSummaryCell',
    inject : ['gridInfo'],
    props : {
        field : {type:Object},
        groupNode : {type:Object},
    },
    computed : {
        tdStyle() {
            let style = Object.assign({},this.field.customStyle);
            if(this.field.__width) {
                var w = this.field.__width;
                if(typeof w === 'number') w = w+'px'
                style.flex = '0 0 '+w;
                style['min-width'] = '0px'
            } else {
                style.flex = "1 1 0px";
                style['min-width'] = this.gridInfo.opts.defaultFieldWidth+'px'
                // TODO add extra logic for cell merge
            }
            return style;
        },
        tdClass() {
            var clazz = [];
            // 1. typed
            switch(this.field.type) {
            case 'number' : clazz.push('ur-data-grid__content__cell--number');break;
            case 'code'   : clazz.push('ur-data-grid__content__cell--code');break;
            case 'date'   : clazz.push('ur-data-grid__content__cell--date');break;
            case 'boolean': clazz.push('ur-data-grid__content__cell--boolean');break;
            default       : clazz.push('ur-data-grid__content__cell--default');break;
            }
            // 2. isGroup?
            if(this.field.__isGroup >= 0) {clazz.push('ur-data-grid__content__group-summary--is-group')}
            // x. Bye~
            return clazz
        },
        valueStyle() {
            let style = {};
            if(this.field.align) {style['text-align'] = this.field.align;}
            return style;// display:flex 될때 문제점은? -> 시부렁 쩜쩜쩜이 잘 안됨
        },
        
        $_text() {
            // 1. summary attribute
            var g = this.groupNode,
                f = this.field,
                s = this.field.summary;
            if(s) {
                if(typeof s === 'string') {return s}
                if(typeof s === 'function'){
                    // TODO concat children data
                    var data = this.concatChildren(this.groupNode);
                    return s(data, this.groupNode)
                }
            }
            // 2. labels
            if(g.group) {
                var key = this.gridInfo.opts.grouping[g.depth]
                if(key === f.value) {
                    return this.cellText(g.value,f);
                }
            }
            // x. and emtpy...
            return ''
        },
        // [COMPUTED] Value, timezone
        timezone() {return this.field.timezone === null ? this.gridInfo.opts.timezone : this.field.timezone}
    },
    methods : {
        cellText(v) {
            var cv = this.field.customValue;
            if(cv && typeof cv ==='function') {
                return cv(v);
            }
            switch(this.field.type) {
            case 'date':
                var fmt = this.field.dateFormat || this.gridInfo.opts.dateFormat;
                return v?dateToText(v,fmt, this.timezone):''
            case 'code':
                if(this.field.__domainMap) {
                    var dobj = this.field.__domainMap.get(v);
                    return dobj?dobj.text:v;
                }
                break;
            default:
                break;
            }
            return v;
        },
        concatChildren(node) {
            if(node.leaf) {
                return node.children
            } else {
                return node.children.reduce((acc, ch)=>{
                    acc.push(...this.concatChildren(ch))
                    return acc;
                },[])
            }
        }
    }
}

</script>

